// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthed-content-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex:1 1;
  background-color: rgba(210, 233, 248, 0.116);
  overflow-x: scroll;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/UnauthedContent/UnauthedContent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,QAAM;EACN,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".unauthed-content-container {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: center;\n  flex:1;\n  background-color: rgba(210, 233, 248, 0.116);\n  overflow-x: scroll;\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
